import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
// Objects
import { CmpFauxDropDownObject, CmpFauxDropDownOptionsObject } from 'src/objects/cmp-faux-dropdown.object';

@Component({
  standalone: false,
  selector: 'cmp-faux-select-meta-dropdown',
  templateUrl: './faux-select-meta-dropdown.component.html'
})
export class FauxSelectMetaDropdownComponent implements OnInit {

  public fauxOption: CmpFauxDropDownObject = new CmpFauxDropDownObject;
  @Input() set optionDetails(value: CmpFauxDropDownObject) {
    this.fauxOption = value;
    this.fsdOpen = false;
  }
  @Output() getSelection = new EventEmitter();

  public elementId = '';
  public fsdOpen = false;
  public selectedValue: string | number = '';
  constructor() { }

  ngOnInit() {
    this.elementId = `${this.fauxOption.label.name}-${new Date()}`;
  }

  /**
   * @method fauxDropDownSelected
   * @description emit selected dropdown
   * @returns void
   */
  public fauxDropDownSelected(option: CmpFauxDropDownOptionsObject) {
    this.getSelection.emit({
      option
    });
  }

  /**
   * @method selectOption
   * @description to select option
   * @returns void
   */
  public selectOption(option: CmpFauxDropDownOptionsObject) {
    this.fsdOpen = false;
    this.fauxOption.label.selectedLabel = option.name;
    if (!option.status) {
      this.selectedValue = option.value;
    }
    this.fauxDropDownSelected(option);
  }
}
